import React from 'react'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button
} from '@chakra-ui/react'

type ConfirmDiscardDialogProps = {
  cancelRef: React.RefObject<HTMLButtonElement>
  isOpen: boolean
  onClose: () => void
  onDiscard: () => void
  resourceLabel: string
}

export default function ConfirmDiscardDialog({
  cancelRef,
  isOpen,
  onClose,
  onDiscard,
  resourceLabel
}: ConfirmDiscardDialogProps) {
  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize='lg' fontWeight='bold'>
            Discard {resourceLabel}?
          </AlertDialogHeader>
          <AlertDialogBody>
            You have unsaved {resourceLabel} details. Close without saving?
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              Keep editing
            </Button>
            <Button colorScheme='red' ml={3} onClick={onDiscard}>
              Discard
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
